export default __webpack_public_path__ + "static/epica-lite-2-143c9e5f280b8dde94a41045452d1bbe.jpg";